import React from 'react'

import { TKeyMetric } from 'types/GlobalKeyMetric'
import { TCustomizedMetric } from 'types/GlobalMetric'

import { useTranslation } from 'language/translator'
import { useAccounts } from 'redux/hooks/Accounts'
import { useGroups } from 'redux/hooks/Groups'

import Button from 'components_new/atoms/Button'

import SidebarDialog from 'components_new/molecules/SidebarDialog'

import MetricEditBody from 'components_new/organisms/MetricEditBody'
import MetricEditSidebar from 'components_new/organisms/MetricEditSidebar'

import { useMetricEdit } from './utils'

interface Props {
  keyMetric?: TKeyMetric | null
  metric: TCustomizedMetric | null
  onClose: () => void
  onSave: (metric: TCustomizedMetric, keyMetric: TKeyMetric | null) => void
  open: boolean
}

const MetricEditDialog = (props: Props) => {
  const { keyMetric, metric, onClose, onSave, open } = props

  const { t } = useTranslation()
  const { loading: accountsLoading } = useAccounts()
  const { loading: groupsLoading } = useGroups()

  const {
    editKeyMetric,
    editMetric,
    handleDistributionChange,
    handleMetricChange,
    handleRollingSumChange,
    handleSlicesChange,
    updateKeyMetric
  } = useMetricEdit({ keyMetric, metric })

  const loading = accountsLoading || groupsLoading

  const handleCancel = () => {
    onClose()
  }

  const handleSave = () => {
    onSave(editMetric, editKeyMetric)
    onClose()
  }

  return (
    <SidebarDialog
      actions={
        <>
          <Button onClick={handleCancel} variant="text">
            {t('global', 'cancel')}
          </Button>
          <Button disabled={editMetric.id === ''} onClick={handleSave}>
            {t('global', 'save')}
          </Button>
        </>
      }
      loading={loading}
      maxWidth="sm"
      onClose={handleCancel}
      open={open}
      rightSidebar={{
        content: (
          <MetricEditSidebar
            editKeyMetric={editKeyMetric}
            onKeyMetricChange={updateKeyMetric}
          />
        )
      }}
      title={`${t('global', 'edit')} ${
        keyMetric
          ? t('key_metrics', 'key_metric', true)
          : t('metrics', 'metric', true)
      }`}
    >
      <MetricEditBody
        displayPreview={true}
        editKeyMetric={editKeyMetric}
        editMetric={editMetric}
        onDistributionChange={handleDistributionChange}
        onKeyMetricChange={updateKeyMetric}
        onMetricChange={handleMetricChange}
        onRollingSumChange={handleRollingSumChange}
        onSlicesChange={handleSlicesChange}
      />
    </SidebarDialog>
  )
}

export default MetricEditDialog
